import { Button, Stack } from '@mui/material'
import { DASHBOARD_COLORS, dashboardPillButtonSx } from './dashboardFormatters'

const RangeButtons = ({ value, options, onChange, compact = false }) => (
  <Stack direction="row" spacing={0.75} sx={{ flexShrink: 0, flexWrap: 'nowrap' }}>
    {options.map((opt) => {
      const active = value === opt.value
      return (
        <Button
          key={opt.value}
          size="small"
          disableElevation
          onClick={() => onChange(opt.value)}
          sx={dashboardPillButtonSx(active, compact)}
        >
          {opt.label}
        </Button>
      )
    })}
  </Stack>
)

export const ChartLegend = ({ items }) => (
  <Stack direction="row" spacing={2} sx={{ mb: 1.5, flexWrap: 'wrap', gap: 1 }}>
    {items.map((item) => (
      <Stack key={item.label} direction="row" spacing={0.75} alignItems="center">
        <span
          style={{
            width: item.line ? 12 : 12,
            height: item.line ? 3 : 12,
            borderRadius: item.line ? 2 : 3,
            background: item.line ? item.color : item.fill || item.color,
            border: item.border ? `1.5px solid ${item.border}` : 'none',
            display: 'inline-block',
            flexShrink: 0,
          }}
        />
        <span style={{ fontSize: '11.5px', color: '#555550' }}>{item.label}</span>
      </Stack>
    ))}
  </Stack>
)

export default RangeButtons
